import React, { Component } from 'react';

class Stats extends Component {
  render() {
    const { stats } = this.props;

    return (
      <div className="Stats" style={{ padding: '20px' }}>
        <table style={{ fontSize: '12px' }}>
          <tbody>
            <tr>
              <td>Gifts:</td>
              <td>€{ parseInt(stats.sumPriceEuro, 10) } ({ stats.numInEuro })</td>
              <td>₪{ parseInt(stats.sumPriceILS, 10) } ({ stats.numInILS })</td>
            </tr>
            <tr>
              <td>Free:</td>
              <td>€{ parseInt(stats.sumPriceEuroFree, 10) } ({ stats.numInEuroFree })</td>
              <td>₪{ parseInt(stats.sumPriceILSFree, 10) } ({ stats.numInILSFree })</td>
            </tr>
            <tr>
              <td>Will buys:</td>
              <td>€{ parseInt(stats.sumPriceEuroWillBuys, 10) } ({ stats.numInEuroWillBuys })</td>
              <td>₪{ parseInt(stats.sumPriceILSWillBuys, 10) } ({ stats.numInILSWillBuys })</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Stats/Stats.js